import { render, staticRenderFns } from "./modalProductivityDetail.vue?vue&type=template&id=b44be804&scoped=true"
import script from "./modalProductivityDetail.vue?vue&type=script&lang=js"
export * from "./modalProductivityDetail.vue?vue&type=script&lang=js"
import style0 from "./modalProductivityDetail.vue?vue&type=style&index=0&id=b44be804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44be804",
  null
  
)

export default component.exports